import { create } from 'zustand';
import { ApiUtils } from '@shared/utils';
import { CardsApi, type setCard3dsRequest } from '@shared/api';

interface SetCard3DSType {
  loading: boolean;
  error: string | null;
  success: boolean;
  set: (request: setCard3dsRequest, cardId?: string, signal?: AbortSignal) => Promise<void>;
  resetError: () => void;
  clear: () => void;
}

export const useSetCard3DSStore = create<SetCard3DSType>((set) => ({
  loading: false,
  data: null,
  error: null,
  success: false,

  set: async (request, cardId, signal) => {
    try {
      set({ loading: true, error: null, success: false });
      await CardsApi.setCard3ds(request, cardId, signal);
      set({ loading: false, success: true });
    } catch (error) {
      set({ loading: false, error: ApiUtils.getApiError(error), success: false });
    }
  },

  resetError: () => set({ error: null }),

  clear: () => set({ loading: false, error: null, success: false }),
}));
